<div class="calendar-container">
  <div class="calendar-header">
    <button type="button" (click)="changeMonth(-1)">&lt;</button>
    <span class="month-label">{{ currentDate | date:'LLLL yyyy' }}</span>
    <button type="button" (click)="changeMonth(1)">&gt;</button>
  </div>

  <div class="calendar-grid">
    <div class="week-day" *ngFor="let wd of weekDays">{{ wd }}</div>

    <div
      class="calendar-day"
      *ngFor="let day of daysInMonth"
      [class.empty]="!day"
      [class.selected]="day && selectedDateStr === getDateString(day)"
      [class.today]="day && getDateString(day) === (today | date:'yyyy-MM-dd')"
      (click)="selectDay(day)"
    >
      <span class="day-number" *ngIf="day">{{ day }}</span>

      <div class="dots" *ngIf="day && getCount(getDateString(day)) > 0">
        <div class="dot" *ngFor="let _ of [].constructor(Math.min(getCount(getDateString(day)), 3))"></div>
        <div class="dot-plus" *ngIf="getCount(getDateString(day)) > 3">+</div>
      </div>
    </div>
  </div>
</div>
